import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { Subscription, debounceTime, first, fromEvent, map } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { DashboardService } from 'src/app/services/dashboard.service';
import { ModalVideoComponent } from '../common/modal-video/modal-video.component';
import { UtilsService } from 'src/app/services/utils.service';
import { CarouselItem, SearchParams } from 'src/app/core/models';
import { SearchSortTypes } from 'src/app/core/enum';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('searchInput') searchInput: ElementRef | undefined;
  sortTypes = SearchSortTypes;
  searchResults: any = [];
  tmpSearchResults = [];
  tmpBaniSearchResults = [];
  originalSearchResults: any[] = [];
  dynamicSlides: CarouselItem[] = [];
  dynamicFeaturedSlides: any = [];
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    autoHeight: false,
    dots: false,
    navSpeed: 600,
    navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      760: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
    nav: false,
  };
  activeSlides: SlidesOutputData | undefined;
  isHandsetPortrait: boolean = false;
  totalRecords: number = 0;
  searchParams: SearchParams = {
    text: '',
    alphabeticSort: '',
    dateSort: 'desc',
  };
  totalPages: number = 0;
  recordsPerPage: number = 48;
  currentPage: number = 1;
  documentScrollObservable?: Subscription;
  verticalScroll: number = 0;
  isInfiniteScrollDisabled: boolean = false;
  isDynamicSlidesLoading: boolean = false;
  isSearchResultsLoading: boolean = false;
  textParam: any = {};
  showAllWord = false;
  showAllBani = false;
  panelOpenState = false;
  dictionaryDetails: any = [];
  wordInstanceDetails: any = [];
  tmpWordInstanceDetails = [];
  // @ViewChild(MatAccordion) accordion!: MatAccordion;
  constructor(
    private dashboardService: DashboardService,
    public dialog: MatDialog,
    private router: Router,
    private utils: UtilsService,
    private route: ActivatedRoute,
    private scroller: ViewportScroller
  ) {}

  ngOnInit(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    this.currentPage = 0;
    /* this.route.queryParams.subscribe(val => {
      this.textParam = val;
      this.searchParams.text = this.textParam?.keyword;
    }); */
    this.route.queryParams.subscribe((params) => {
      // ✅ Create a new mutable copy
      this.textParam = { ...params };
      this.searchParams.text = params['keyword'] || '';
      this.textParam.type = params['type'] || 'Keyword'; // now safe
      this.currentPage = +params['page'] || 0;
      this.searchParams.alphabeticSort = params['alphabeticSort'] || '';
      this.searchParams.dateSort = params['dateSort'] || 'desc';

      if (params || this.searchParams.text) {
        this.dictionary(this.searchParams.text);
        this.fetchWordInstance(this.searchParams.text);
      }
    });
    this.fetchCarouselItems();

    const source = fromEvent(document, 'scroll');

    this.documentScrollObservable = source.subscribe({
      next: () => {
        this.verticalScroll = Math.round(
          this.utils.getVerticalScrollPercentage(document.body)
        );
        if (
          this.verticalScroll > 70 &&
          this.showAllBani &&
          !this.isInfiniteScrollDisabled &&
          this.totalRecords > 50
        ) {
          this.isInfiniteScrollDisabled = true;
          // console.log('load more')
          this.loadMore();
        }
      },
    });
  }

  ngAfterViewInit(): void {
    this.scroller.scrollToPosition([0, 530]);

    const searchKeyUp$ = fromEvent(this.searchInput?.nativeElement, 'keyup');
    searchKeyUp$
      .pipe(
        map((i: any) => i.currentTarget.value),
        debounceTime(500)
      )
      .subscribe({
        next: (searchedTerm: string) => {
          if (this.searchParams.text && this.textParam.type === undefined) {
            this.textParam = { type: 'Keyword' };
          } else {
            this.textParam = { type: this.textParam.type };
          }
          this.currentPage = 0;
          this.searchResults = [];
          this.showAllBani = false;
          this.showAllWord = false;
          this.dictionaryDetails = [];
          this.wordInstanceDetails = [];
          this.tmpWordInstanceDetails = [];
          if (searchedTerm || this.textParam?.keyword) {
            this.dictionary(searchedTerm || this.textParam?.keyword);
            this.fetchWordInstance(searchedTerm || this.textParam?.keyword);
          }

          this.fetchCarouselItems();
        },
        error: (keyUpError) => {
          console.log('key up error ', keyUpError);
        },
      });
  }

  toggleSortOptions(type: string): void {
    if (type === SearchSortTypes.ALPHABETIC) {
      this.searchParams.alphabeticSort =
        this.searchParams.alphabeticSort === 'asc' ? 'desc' : 'asc';
      this.searchParams.dateSort = '';
    } else {
      if (this.searchParams?.dateSort) {
        this.searchParams.dateSort =
          this.searchParams.dateSort === 'asc' ? 'desc' : 'asc';
      } else {
        this.searchParams.dateSort = 'desc';
      }
      this.searchParams.alphabeticSort = '';
    }
    this.currentPage = 0;
    this.searchResults = [];
    this.fetchCarouselItems();
  }

  openVideoPopup(videoURL: string): void {
    if (videoURL) {
      this.dialog.open(ModalVideoComponent, {
        data: { videoURL },
      });
    }
  }

  openBaniDashboard(baniCode: string): void {
    this.router.navigate(['/bani', baniCode]);
  }

  getPassedData(data: SlidesOutputData): void {
    this.activeSlides = data;
  }

  getData(event: SlidesOutputData): void {
    // console.log(event);
  }

  onScroll(): void {
    this.currentPage = this.currentPage + 1;
    this.fetchCarouselItems();
    this.ResetUpdateData();
  }

  loadMore(): void {
    this.currentPage = this.currentPage + 1;
    this.fetchCarouselItems();
    this.ResetUpdateData();
  }

  fetchCarouselItems(): void {
    if (this.totalPages && this.currentPage > this.totalPages) return;

    this.isSearchResultsLoading = true;
    const searchedTerm = this.searchParams.text
      ? this.searchParams.text.trim()
      : this.searchParams.text;

    // below are changes of new search api tag
    // if (!this.textParam?.type) {
    //   this.textParam = { type: '' }
    // }
    // else {
    //   this.textParam.type = '';
    // }
    // if (this.searchParams?.text?.trim()) {
    //   this.dashboardService.getTags(this.searchParams.text.trim()).subscribe(val => {
    //     if (val?.value?.length)
    //       this.textParam.type = val?.value[0]?.TypeOfTag
    //   })
    // }
    this.dashboardService
      .fetchAllSearchAbleData(
        searchedTerm || this.textParam?.keyword || '',
        this.searchParams.alphabeticSort,
        this.searchParams.dateSort,
        this.currentPage,
        this.textParam?.type
      )
      .pipe(first())
      .subscribe({
        next: (data: any) => {
          if (data?.value.length > 0) {
            this.isSearchResultsLoading = false;

            this.originalSearchResults = data?.value || [];

            this.searchResults = data?.value || [];
            this.tmpSearchResults = JSON.parse(
              JSON.stringify(this.searchResults)
            );
            this.tmpBaniSearchResults = JSON.parse(
              JSON.stringify(this.searchResults)
            );

            //this.updateSearchResults(data);

            // console.log("SearchTerm : ", searchedTerm, "Text Param : ", this.textParam?.type)
            /* this.totalRecords =
               data && data['@odata.count'] ? data['@odata.count'] : 0;*/
            this.totalRecords = this.searchResults?.length;
            this.totalPages = Math.ceil(
              this.totalRecords / this.recordsPerPage
            );
            if (
              this.searchResults?.length > 3 &&
              (searchedTerm || this.textParam?.keyword) &&
              !this.showAllBani
            ) {
              this.searchResults = this.searchResults.slice(0, 3);
              // this.searchResults.length = 3;
            }
            setTimeout(() => {
              this.isInfiniteScrollDisabled = false;
            }, 500);
          } else {
            this.isSearchResultsLoading = false;
          }
        },
        error: (err) => {
          console.log('dashboard data error ', err);
        },
      });

    this.isDynamicSlidesLoading = true;
    this.updateUrl();
    this.dashboardService
      .fetchCarouselItems()
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.isDynamicSlidesLoading = false;
          this.dynamicSlides = res?.value?.length ? res.value : [];
        },
        error: (e: any) => {
          this.dynamicSlides = [];
          console.error('error in fetching carousel items', e);
        },
      });
  }
  updateUrl() {
    const keyword = this.searchParams.text?.trim();

    if (!keyword) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {},
      });
      return;
    }

    const queryParams: any = {
      keyword: keyword,
    };

    if (this.textParam?.type) {
      queryParams.type = this.textParam.type;
    }

    if (this.currentPage) {
      queryParams.page = this.currentPage;
    }

    if (this.searchParams.alphabeticSort) {
      queryParams.alphabeticSort = this.searchParams.alphabeticSort;
    }

    if (this.searchParams.dateSort && this.searchParams.dateSort !== 'desc') {
      queryParams.dateSort = this.searchParams.dateSort;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
    });
  }
  dictionary(searchedTerm: string) {
    this.dashboardService
      .dictioanrySearch(searchedTerm || this.textParam?.keyword)
      .subscribe((val) => {
        this.dictionaryDetails = val.value;
      });
  }

  fetchWordInstance(searchedTerm: string) {
    this.dashboardService
      .wordInstance(searchedTerm || this.textParam?.keyword)
      .subscribe((val) => {
        this.wordInstanceDetails = val.value;
        this.tmpWordInstanceDetails = JSON.parse(
          JSON.stringify(this.wordInstanceDetails)
        );
        this.wordInstanceDetails.length =
          this.wordInstanceDetails.length > 6
            ? 6
            : this.wordInstanceDetails.length;
      });
  }

  navigate(word: any) {
    /* const searchedTerm = this.searchParams.text
    //this.router.navigate(['/compositions/bani/details', word.BaniCode, word.SectionSequence, word.SubSectionSequence]);
    this.router.navigate([]).then(result => {  window.open(`/bani/details/${word.BaniCode}/${word.SectionSequence}/${word.SubSectionSequence}/?txt=${searchedTerm}`, '_blank'); }); */
    const searchedTerm = this.searchParams.text;
    window.open(
      `/bani/details/${word.BaniCode}/${word.SectionSequence}/${word.SubSectionSequence}/?txt=${searchedTerm}`,
      '_blank'
    );
  }

  // Define a method to filter the data based on search criteria
  filterBaniDataOnclickSearchType(
    filtertype: string,
    searchedTerm: string
  ): any {
    let filterCondition: any;
    switch (filtertype) {
      case 'Keyword':
        filterCondition = (a: any, b: any) =>
          parseFloat(b['@search.score']) - parseFloat(a['@search.score']);
        break;
      case 'Author':
        filterCondition = (item: { Search_Details: { Author: string }[] }) =>
          item?.Search_Details[0]?.Author &&
          item?.Search_Details[0]?.Author?.toLowerCase() ===
            searchedTerm?.toLowerCase();
        break;
      case 'PageNumber':
        filterCondition = (item: { Search_Details: { PageNumber: any }[] }) =>
          (item?.Search_Details[0]?.PageNumber &&
            item?.Search_Details[0]?.PageNumber[0]?.PageNumberStart ===
              searchedTerm) ||
          item?.Search_Details[0]?.PageNumber[0]?.PageNumberEnd ===
            searchedTerm;
        break;
      case 'SabadTitle':
        filterCondition = (item: {
          Search_Details: { SabadTitle: string }[];
        }) =>
          item?.Search_Details[0]?.SabadTitle &&
          item?.Search_Details[0]?.SabadTitle === searchedTerm;
        break;
      case 'Tags':
        filterCondition = (item: {
          Search_Details: {
            Author: string;
            PageNumber: string;
            SabadTitle: string;
          }[];
        }) =>
          item?.Search_Details[0]?.Author ||
          item?.Search_Details[0]?.PageNumber ||
          item?.Search_Details[0]?.SabadTitle === searchedTerm;
        break;
      default:
        filterCondition = () => true; // Return original data if type is not recognized
        this.tmpBaniSearchResults?.filter(filterCondition);
    }

    return filtertype == 'Keyword'
      ? this.tmpBaniSearchResults?.sort(filterCondition)
      : this.tmpBaniSearchResults?.filter(filterCondition);
  }

  searchType(type: string) {
    this.isSearchResultsLoading = true;
    this.textParam = { type };
    let newResult: any = [];
    //this.fetchCarouselItems();
    const searchedTerm = this.searchParams.text
      ? this.searchParams.text.trim()
      : this.searchParams.text;
    const filterType = type;
    this.updateUrl();
    newResult = this.filterBaniDataOnclickSearchType(filterType, searchedTerm);

    this.searchResults = newResult;
    this.tmpSearchResults = newResult;

    if (newResult.length > 3) {
      this.searchResults = this.searchResults.slice(0, 3);
      this.showAllBani = false;
    }
    this.totalRecords = this.searchResults?.length;
    this.totalPages = Math.ceil(this.totalRecords / this.recordsPerPage);
    setTimeout(() => {
      this.isInfiniteScrollDisabled = false;
    }, 500);

    this.isSearchResultsLoading = false;
    //this.updateSearchResults(this.originalSearchResults);
  }

  updateSearchResults(data: any) {
    // Extract new results from the API response
    const newResults = data?.value || [];

    // Filter out duplicates by checking if the ID is already present
    const uniqueNewResults = newResults.filter((newResult: { id: any }) => {
      const existingResult = this.searchResults.find(
        (result: { id: any }) => result.id === newResult.id
      );
      return !existingResult;
    });

    // Add unique new results to the searchResults array
    this.searchResults = [...this.searchResults, ...uniqueNewResults];
  }

  ResetUpdateData(): void {
    this.isSearchResultsLoading = true;
    const searchedTerm = this.searchParams.text
      ? this.searchParams.text.trim()
      : this.searchParams.text;
    this.originalSearchResults = JSON.parse(JSON.stringify(this.searchResults));
    if (searchedTerm && this.textParam?.type === 'Keyword') {
      this.searchResults = this.originalSearchResults;
      this.searchResults?.sort(
        (a: any, b: any) =>
          parseFloat(b['@search.score']) - parseFloat(a['@search.score'])
      );
    } else if (searchedTerm && this.textParam?.type === 'Author') {
      this.searchResults = this.originalSearchResults;
      let newResult = this.searchResults?.filter(
        (item: { Search_Details: { Author: string }[] }) =>
          item?.Search_Details[0]?.Author &&
          item?.Search_Details[0]?.Author?.toLowerCase() ===
            searchedTerm?.toLowerCase()
      );
      this.searchResults = [];
      this.searchResults = newResult;
      //console.log(newResult)
    } else if (searchedTerm && this.textParam?.type === 'PageNumber') {
      this.searchResults = this.originalSearchResults;
      let newResult = this.searchResults?.filter(
        (item: { Search_Details: { PageNumber: string }[] }) =>
          item?.Search_Details[0]?.PageNumber &&
          item?.Search_Details[0]?.PageNumber === searchedTerm
      );
      this.searchResults = [];
      this.searchResults = newResult;
    } else if (searchedTerm && this.textParam?.type === 'SabadTitle') {
      //console.log("Previous Result : ", this.searchResults)
      this.searchResults = this.originalSearchResults;
      let newResult = this.searchResults?.filter(
        (item: { Search_Details: { SabadTitle: string }[] }) =>
          item?.Search_Details[0]?.SabadTitle &&
          item?.Search_Details[0]?.SabadTitle === searchedTerm
      );
      this.searchResults = [];
      // console.log("Result : ", newResult)
      this.searchResults = newResult;
    } else if (searchedTerm && this.textParam?.type === 'Tags') {
      //console.log("Previous Result : ", this.searchResults)
      this.searchResults = this.originalSearchResults;
      let newResult = this.searchResults?.filter(
        (item: {
          Search_Details: {
            Author: string;
            PageNumber: string;
            SabadTitle: string;
          }[];
        }) =>
          item?.Search_Details[0]?.Author ||
          item?.Search_Details[0]?.PageNumber ||
          item?.Search_Details[0]?.SabadTitle === searchedTerm
      );
      this.searchResults = [];
      // console.log("Result : ", newResult)
      this.searchResults = newResult;
    } else {
      this.searchResults = this.originalSearchResults;
    }

    this.totalRecords = this.searchResults?.length;
    this.totalPages = Math.ceil(this.totalRecords / this.recordsPerPage);
    setTimeout(() => {
      this.isInfiniteScrollDisabled = false;
    }, 500);
    this.isSearchResultsLoading = false;
  }

  fetchImageThumbnail(baniItem: any) {
    return baniItem.BaniVideoURL
      ? this.utils.fetchImageThumbnail(baniItem.BaniVideoURL)
      : baniItem.BaniImageURL?.trim()
      ? baniItem.BaniImageURL
      : '/assets/images/mediaPlaceholder.webp';
  }

  showSmallerString(descriptionText: string): string {
    return this.utils.showSmallerString(descriptionText);
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
    setTimeout(() => {
      this.customOptions = { ...this.customOptions };
    }, 200);
  }

  moreBani() {
    this.searchResults = JSON.parse(JSON.stringify(this.tmpSearchResults));
    this.totalRecords = this.searchResults.length;
  }

  moreWord() {
    this.wordInstanceDetails = this.tmpWordInstanceDetails;
  }

  back() {
    if (this.showAllBani) {
      this.showAllBani = false;
      this.searchResults = this.searchResults.slice(0, 3);
    }
    if (this.showAllWord) {
      this.showAllWord = false;
      this.wordInstanceDetails.length =
        this.wordInstanceDetails.length > 3
          ? 3
          : this.wordInstanceDetails.length;
    }
  }

  ngOnDestroy(): void {
    this.documentScrollObservable?.unsubscribe();
  }
}
